<app-wrapper>
    <app-in-develop></app-in-develop>
    <!--<div class="mb-9">
		<div class="row g-3 mb-4">
			<div class="col-auto">
				<h2 class="mb-0">История рассылок</h2>
			</div>
		</div>

		<div class="mb-4">
            <div class="row g-3">
                <div class="col-auto">
                    <div class="search-box">
                        <div class="position-relative">
                            <input type="text" class="form-control search-input search" [(ngModel)]="search"
                                name="search" placeholder="Поиск" (keyup.enter)="searchItems()" />
                            <i class="fa-solid fa-search search-box-icon"></i>
                        </div>
                    </div>
                </div>
                <div class="col-auto flex-grow-1">

                </div>
                <div class="col-auto">
                    <button [routerLink]="['/push/create']" class="btn btn-primary" type="button">
                        <i class="fa-solid fa-plus"></i>&nbsp;Добавить рассылку
                    </button>
                </div>
            </div>
        </div>

        <div class="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white border-top border-bottom border-200 position-relative top-1">
            <div class="table-responsive mx-n1 px-1">
                <table class="table fs--1 mb-0">
                    <thead>
						<tr>
							<th style="width: 20%;">Дата</th>
							<th style="width: 20%;" class="text-center">Отправитель</th>
							<th style="width: 30%;">Заголовок</th>
							<th style="width: 30%;">Текст</th>
						</tr>
					</thead>
					<tbody class="list">
						<tr *ngFor="let item of items">
							<td>
								{{ item.date | date: 'dd.MM.yyyy HH:mm' }}
							</td>
							<td class="text-center">
								{{ item.sender }}
							</td>
							<td>
								{{ item.caption }}
							</td>
							<td>
								{{ item.text }}
							</td>
						</tr>
						<tr *ngIf="!isBusy && items?.length == 0">
							<td colspan="10" class="text-center">
								Список пуст
							</td>
						</tr>
					</tbody>
                </table>
            </div>
            <div class="d-flex justify-content-end py-2 pe-0 fs--1">
                <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" [ngClass]="{'disabled': page === 1}" (click)="getData(page - 1)">
                        <a onclick="return false;" class="page-link" href="#" tabindex="-1">
                            <span aria-hidden="true"><i class="fa-solid fa-chevron-left"></i></span>
                        </a>
                    </li>
                    <li class="page-item" *ngFor="let item of getPages()"
                        [ngClass]="{'active': page === item.page, 'disabled': item.isDisabled}"
                        (click)="getData(item.page)">
                        <a class="page-link" onclick="return false;" href="#">{{ item.label }}</a>
                    </li>
                    <li class="page-item" [ngClass]="{ 'disabled': !pages || page === pages }"
                        (click)="getData(page + 1)">
                        <a onclick="return false;" class="page-link" href="#">
                            <span aria-hidden="true"><i class="fa-solid fa-chevron-right"></i></span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="overlay" *ngIf="isBusy">
            <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
	</div>
-->
</app-wrapper>